import React, { useState, useEffect } from "react";
import HomeFeatures from "../components/aarogyaone-emr-features";
import HomeBenefits from "../components/aarogyaone-emr-benefits";
import HomeSlider from "../components/aarogyaone-emr-slider";

import HomeHowItWorksNew from "../components/aarogyaone-emr-howitworks";
import HomeBlogs from "../components/aarogyaone-emr-blogs";
import HomeTestimonials from "../components/aarogyaone-emr-testimonials";
import HomeVblogs from "../components/aarogyaone-emr-vbologs";
import { Helmet } from "react-helmet";
import fetchData from "../services/requester";

const AarogyaOneEMR = (props) => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);

  const getData = () => {
    let reqURL = "aarogyaone-emr.json";
    fetchData(reqURL, null, (res) => {
      setData(res);
      setLoading(false);
    });
  };


  

  useEffect(() => {
    getData();
    window.scrollTo(0, -1);
  }, []);

  return (
    <div className="home">
      <Helmet>
        <title>{data?.title}</title>
        <meta name="keywords" content={data?.keywords} />
        <meta name="description" content={data?.desscription} />
      </Helmet>

      <HomeSlider {...data} handleDownloads={props.handleDownloads} />
      {!loading && (
        <div style={{ background: "#fff", position: "relative" }}>
          <HomeFeatures {...data} />
          <HomeHowItWorksNew {...data} />
          <HomeBenefits {...data} />
          {/* <HomeWhoWeAre {...data} /> */}
          <HomeTestimonials {...data} />
          <HomeBlogs {...data} />
          <HomeVblogs {...data} />
        </div>
      )}
    </div>
  );
};

export default AarogyaOneEMR;
